import Container from "react-bootstrap/Container";
import { Card, Row, Col,Table } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import ProgressBar from "@ramonak/react-progress-bar";
import  '../CSS/styles.scss'
import TableScrollbar from 'react-table-scrollbar';
import React,{useEffect,useState} from "react";
import ApexChart from '../Grpahs/ApexChart';
import LeadsByMonth2 from '../database/LeadsByMonth2.json'
import LeadsByMonth1 from '../database/LeadsByMonth1.json'

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import LeadsOverviewDb from '../database/LeadsOverviewDb.json';


import LeadsByMonth from "../database/LeadsByMonth.json";
import Header from "./Header";





export const LeadsOverview = () => {


  const [ttl, setttl]=useState(0);
  const [perTa, setPerTa]=useState(0);


  function handleJson(LeadsByMonth2){
    let label=[]
    let y=[]
      LeadsByMonth2.forEach((ele)=>{
      label.push(ele.label)
      y.push(ele.y)
    })
    return {label:label , y:y}
  }

  function handleJson2(LeadsByMonth){
    let label=[]
    let y=[]
      LeadsByMonth.forEach((ele)=>{
      label.push(ele.label)
      y.push(ele.y)
    })
    return {label:label , y:y}
  }




  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
  };


  useEffect(()=>{
    userAdd();
    userPerAdd();
    
  },[])



  function userAdd(){
    const rec = LeadsOverviewDb
    var sum=0;
      for(var i=0; i<rec.length; i++){
        sum += parseInt(rec[i].tL)
      }
      setttl(sum)
    }

    function userPerAdd(){
      const rec = LeadsOverviewDb
      var sum=0;
        for(var i=0; i<rec.length; i++){
          sum += parseInt(rec[i].perTL)
        }
        setPerTa(sum)
      }




  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'80%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "50px" }}>
                    <strong>&nbsp;&nbsp;&nbsp;Leads Overview</strong>
                  </h2>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      boxShadow: "2px 2px 8px ",

                      height: "100px",
                      width: "210px",
                      marginTop: "3px",
                      marginLeft: "52px",
                      position:'initial',
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>17</h1>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop: "3px",
                      // position:'initial',
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      <DateRangeComp />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial',
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Card style={{ boxShadow: "2px 2px 8px ", position:'initial',}}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Slider
                  {...settings}
                  className="slider"
                  style={{ margin: "1px" }}
                >
                  <div>
                    <Button variant="secondary">Chandigarh</Button>
                  </div>
                  <div>
                    <Button variant="secondary">Chile</Button>
                  </div>
                  <div style={{position:'initial',}}>
                    <Button variant="secondary" style={{position:'initial',}}>Chitwan</Button>
                  </div>
                  <div>
                    <Button variant="secondary">Dang</Button>
                  </div>
                  <div>
                    <Button variant="secondary">Australia</Button>
                  </div>
                  <div>
                    <Button variant="secondary">United Kingdom</Button>
                  </div>
                  <div>
                    <Button variant="secondary">Nepal</Button>
                  </div>
                </Slider>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={6}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial', }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Slider
                  {...settings}
                  className="slider"
                  style={{ margin: "1px" }}
                >
                  <div>
                    <Button variant="secondary">2017</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                </Slider>
              </Card.Body>
            </Card>
          </Col>
        </Row>

      
        <Row style={{marginTop:'5px'}}>
          <Col xs={5}>  
          <Card style={{boxShadow: "2px 2px 8px ",height:'410px',position:'initial',}}>
          
          
          <Card.Body style={{padding:'4px'}}>
          <div style={{height: "30vh"}}>
          <TableScrollbar rows={13}>
          
          
          <Table responsive="sm">
          
          <thead className="tableHeader">
            <tr>
            <th>
            Lead Stage
            </th>
            <th>Total Leads</th>
            <th>% of Total Leads</th>
            
            
            </tr>
          </thead>
         
          
          <tbody >
          
          
         
          
          {
            LeadsOverviewDb.map((user=>(
            
             

 
               <tr>

              <td>{user.desti}</td>
              
              
              <td className="percentae" ><ProgressBar 
              completed={user.tL}
              customLabel={user.tL}
              labelClassName="label"
              maxCompleted={1600}
              bgColor='#ff6666'
              baseBgColor='none'
             
              
              
               /></td>
              <td >
              
              <ProgressBar 
              completed={user.perTL}
              customLabel={user.perTL}
              
              maxCompleted={5}
              // bgColor='#eb8a5f'
              backgroundColor= '["red", "blue", "green", "blue", "red", "blue"]'
              baseBgColor='none'
              className="wrapper"
              barContainerClassName="container"
              completedClassName="barCompleted"
              labelClassName="label"
              

               />
              
              
              
              </td>
              
               </tr>


              
             )))

             
           }
           
           
          
          <tr style={{position:'sticky',boxShadow: "1px -4px 18px 0px orangered", backgroundColor:'#5560ee', color:'white'}}>
          <td><strong>Total:</strong></td>
          <td><strong>{ttl}</strong>
          </td>
          <td><strong>{perTa}%</strong></td>
          
          </tr>
          </tbody>
          </Table>
          </TableScrollbar>
           </div>
          </Card.Body>
          
          
          </Card>

          
          </Col>
          <Col xs={7}>
            <Row>
              <Col>
                <Card style={{boxShadow: "2px 2px 8px ",position:'initial',height:'205px'}}>
                  <Card.Title style={{textAlign:'center', textDecoration:'underline'}}>Leads by Intrested Country</Card.Title>
                  <Card.Body>
                    <LeadsByMonthGraph
                      graphType="column"
                      db={LeadsByMonth1}
                      color="#273e23"
                      height="140"
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card style={{ marginTop: "3px",boxShadow: "2px 2px 8px ",height:'205px' }}>
                  <Card.Title style={{textAlign:'center', textDecoration:'underline'}}>Leads By Month</Card.Title>
                  <Card.Body style={{paddingBottom:'0px',padding:'0px'}}>
                    <ApexChart
                    graphType='line'
                    graphType2='column'
                    height='190'
                    // db={LeadsByMonth2}
                    db2={handleJson2(LeadsByMonth).y}
                    labels={ handleJson(LeadsByMonth).label}
                    db={ handleJson(LeadsByMonth2).y}
                    
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
export default LeadsOverview;
